import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { Typography } from '@mui/material';
import loaderStyles from './dotsLoader.styles';
export const DotsLoader = ({ className, dataTest, }) => {
    const style = loaderStyles();
    return (_jsx(Typography, { component: "span", className: className, children: _jsxs("span", { "data-test": dataTest, children: [_jsx("span", { className: clsx(style.loaderDot1, style.loaderDot), children: "\u2022" }, void 0), _jsx("span", { className: clsx(style.loaderDot2, style.loaderDot), children: "\u2022" }, void 0), _jsx("span", { className: clsx(style.loaderDot3, style.loaderDot), children: "\u2022" }, void 0)] }, void 0) }, void 0));
};
//# sourceMappingURL=DotsLoader.js.map